<button class="border-2 rounded-[16px] w-[240px] p-5 flex flex-col justify-center gap-5 text-start"
    [ngClass]="isSelected ? 'border-primary bg-primary-100' : 'border-border bg-[#FFFFFF]'" *ngIf="folderInfo">
    <app-folder-icon [folderColor]="folderInfo.folderColor!"
        [backgroundColor]="folderInfo.folderBackgroundColor!"></app-folder-icon>
    <p class="font-bold text-xl line-clamp-2">{{folderInfo.name | transloco}}</p>
    <p class="text-neutral-1200 text-sm" *ngIf="folderInfo.numberOfFiles !== null">{{folderInfo.numberOfFiles}} {{ 'archive.files' | transloco }}</p>
</button>